export const getTableRowIsDisabledClassName = (tableRowData) => (
    tableRowData?.is_cancelled ? '--is-disabled' : null
);
